export const gradesTwoFourPoemsAndPassagesIntroSteps = [
  {
    element: '#resources-title',
    intro: 'Poems & Passages is where you can download all of the connected text students are reading and listening to in the WordFlight System. WordFlight recommends all students read aloud with their teacher weekly.'
  },
  {
    element: '#backButton',
    intro: 'Click here to go back to the Grades 2-4 menu page.'
  },
  {
    element: '.student-dropdown-row',
    intro: 'Select a grade level from the Sub-Category dropdown to view the connected texts for that specific grade level.'
  },
  {
    element: '#resourcesTableHeader',
    intro: 'Scroll until you find the unit and grade level connected texts you want to download. Click the file to download it.'
  }
];